import * as yup from "yup";
import { MSG } from "../constants/MSG";

export const addCuisineSchema = yup.object().shape({
	name: yup
		.string()
		.trim()
		.matches(
			/^[a-zA-Z0-9_ ]*$/,
			"Special characters and spaces are not allowed in cuisine"
		)
		.required(MSG.REQUIRED_CUISINE_NAME),
	//is_active: yup.number().required("Please select status"),
});
